import * as React from 'react';
import { useRouteData } from 'react-static';
import { useDebug } from '../../common/hooks/useDebug';
import { useTranslations } from '../../common/translation';
import { BrandsCollectionsResults } from '../../components/brands-collections-results/BrandsCollectionsResults';
import { BrandsUKCollectionsResults } from '../../components/brands-collections-results/BrandsUKCollectionsResults';
import { FeaturedBanner } from '../../components/featured-banner/FeaturedBanner';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { MARKET } from '../../config/browser';
import { DefaultLayout } from '../default/DefaultLayout';
import { CollectionsUKProps } from '../default/DefaultLayout.props';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const { locale, translatedPaths, nids } = useRouteData<CollectionsUKProps>();
  const { t } = useTranslations(translations, locale);
  const seo = {
    description: '',
  };
  let bannerClass = '';
  let bannerUrl = '/assets/images/banner/default-wb.jpg';
  let bannerUrlTablet = '/assets/images/banner/default-wb-tablet.jpg';
  let bannerUrlMobile = '/assets/images/banner/default-wb-mobile.jpg';
  if (MARKET === 'BR') {
    bannerUrl = '/assets/images/banner/brazil-banner.jpg';
    bannerUrlTablet = '/assets/images/banner/brazil-banner-tablet.jpg';
    bannerUrlMobile = '/assets/images/banner/brazil-banner-mobile.jpg';
    bannerClass = 'collections-br';
  }
  const alt = t('imageAlt', 'WB Collections');
  const imageWithPresets: ImageWithPresets = {
    image: {
      alt,
      src: bannerUrl,
    },
    tabletImage: {
      alt,
      src: bannerUrlTablet,
    },
    mobileImage: {
      alt,
      src: bannerUrlMobile,
    },
  };

  useDebug('app:layout:CollectionsLayout', { props: { locale } });

  return (
    <DefaultLayout locale={locale} seo={seo} translatedPaths={translatedPaths}>
      <HeadTitle title={t('pageTitle', 'Collections')} />
      <FeaturedBanner
        headingTag='h1'
        titleProps={{
          title: t('bannerTitle', 'Collections'),
          addlTitleData: {
            marketingMessage: t(
              'bannerSubTitle',
              'Family favorites, romantic movies and the best of the ‘80s… Whatever you’re feeling, ' +
                'we’ve got a curated list to match it.',
            ),
          },
        }}
        imageWithPresets={imageWithPresets}
        bannerClassName={bannerClass}
      />
      {MARKET !== 'UK' && (
        <BrandsCollectionsResults contentType='Collections' query='f[0]=type:collections&qt=%20&size=10' />
      )}
      {MARKET === 'UK' && (
        <BrandsUKCollectionsResults
          contentType='Collections'
          query='f[0]=type:collections&qt=%20&size=10'
          nids={nids}
        />
      )}
    </DefaultLayout>
  );
};
